import React from 'react';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';

import { getTranslatedString } from 'helpers/i18n';

import { updateUserNotificationPreferences } from 'actions/userTypesActions';

import { AccentColor } from 'helpers/AccentColorHelper';

import NotificationPreferencesForm from './NotificationPreferencesForm';

const NotificationPreferencesDialog = (props) => {
  const updateNotificationPreferences = async (formData) => {
    await props.updateUserNotificationPreferences(formData);
    window.gtag('event', 'update_user_notification_preferences', {
      event_category: 'engagement',
    });
    props.toggleDialog();
  };

  return (
    <Formik
      initialValues={{
        notification_preferences: props.notificationPreferences,
        notice_by_email: props.noticeByEmail,
        digital_legal_documents: props.digitalLegalDocuments,
      }}
      onSubmit={updateNotificationPreferences}
    >
      {({ submitForm, values, setFieldValue }) => {
        return (
          <Dialog
            disableBackdropClick
            open={props.isOpen}
            onClose={props.toggleDialog}
            aria-label="notification-preferences-dialog"
            classes={{ paper: 'form-dialog' }}
            fullScreen={props.fullScreen}
          >
            <DialogTitle id="payment-details-dialog" style={{ paddingBottom: '0px' }}>
              <h3 style={{ margin: '10px 0 0' }}>
                {getTranslatedString('portal.viewMessagingPreferences')}
              </h3>
            </DialogTitle>
            <DialogContent>
              <Form>
                <NotificationPreferencesForm values={values} setFieldValue={setFieldValue} />
              </Form>
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <FlatButton
                id="close-button"
                style={{ color: AccentColor() }}
                onClick={props.toggleDialog}
              >
                {getTranslatedString('close')}
              </FlatButton>
              <FlatButton
                onClick={submitForm}
                style={{ float: 'right', color: 'white', backgroundColor: AccentColor() }}
              >
                {getTranslatedString('update')}
              </FlatButton>
            </DialogActions>
          </Dialog>
        );
      }}
    </Formik>
  );
};

const mapStoreToProps = (store) => ({
  notificationPreferences: store.userTypes.notificationPreferences,
  noticeByEmail: store.userTypes.noticeByEmail,
  digitalLegalDocuments: store.userTypes.digitalLegalDocuments,
});

const mapDispatchToProps = { updateUserNotificationPreferences };

export default withMobileDialog()(
  connect(mapStoreToProps, mapDispatchToProps)(NotificationPreferencesDialog)
);
